import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { InstructorProvider, useInstructor } from './context/InstructorContext';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import MyStudents from './pages/MyStudents';
import AppLoader from './components/AppLoader';
import { useMediaQuery } from 'react-responsive';

const AppContent = ({ isSidebarOpen, setIsSidebarOpen, isDesktop, basename }) => {
  const { loading } = useInstructor();
  return (
    <>
      <AppLoader appName="Instructor Portal" loading={loading} />
      <div className="flex" style={{ minHeight: '100vh', position: 'relative' }}>
        {isSidebarOpen && !isDesktop && (
          <div
            onClick={() => setIsSidebarOpen(false)}
            style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 40, backdropFilter: 'blur(4px)' }}
          />
        )}
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} isDesktop={isDesktop} />
        <main style={{ marginLeft: isDesktop ? 'var(--sidebar-width)' : 0, flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Routes>
            <Route path="/" element={<DashboardLayout setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />} />
            <Route path="/students" element={<StudentsLayout setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />} />
            <Route path="*" element={<DashboardLayout setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />} />
          </Routes>
        </main>
      </div>
    </>
  );
};

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const getBasename = () => {
    const config = window.reactPress || window.rpVars || {};
    if (config.post?.permalink) {
      try { return new URL(config.post.permalink).pathname.replace(/\/$/, ''); }
      catch (e) { return '/instructor'; }
    }
    return window.location.port === '3000' ? '' : '/instructor';
  };

  return (
    <InstructorProvider>
      <Router basename={getBasename()}>
        <AppContent isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />
      </Router>
    </InstructorProvider>
  );
}

const DashboardLayout = ({ setIsSidebarOpen, isDesktop }) => (
  <><Header title="Dashboard" setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} /><Dashboard /></>
);
const StudentsLayout = ({ setIsSidebarOpen, isDesktop }) => (
  <><Header title="My Students" setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} /><MyStudents /></>
);

export default App;
